import type { TRouteObject } from "@ch/helpers/utils/types";
import ErrorPage from "@ch/pages/ErrorPage";
import NotFoundPage from "@ch/pages/NotFoundPage";
import SubscriptionPageLazy from "@ch/pages/SubscriptionsPage";
import BaseLineAssessmentsLazy from "@ch/pages/SubscriptionsPage/tabs/BLA/assessment";
import MyPlan from "@ch/pages/SubscriptionsPage/tabs/MyPlan";
import SubscriptionTabsLazy from "@ch/pages/SubscriptionsPage/tabs/index";
import { lazy } from "react";
import { SubscriptionPathsEnum } from "./enums";

const AssessmentCompleted = lazy(
  () =>
    import("@ch/pages/SubscriptionsPage/tabs/BLA/assessment/AssessmentCompleted"),
);
const RedirectToPHQ = lazy(
  () => import("@ch/pages/SubscriptionsPage/tabs/BLA/assessment/RedirectToPHQ"),
);
const GetStartedBLA = lazy(
  () => import("@ch/pages/SubscriptionsPage/tabs/BLA/assessment/GetStartedBLA"),
);

const SubscriptionRoutes: TRouteObject[] = [
  {
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: <SubscriptionPageLazy />,
      },
      {
        path: SubscriptionPathsEnum.PLANS,
        element: <MyPlan />,
      },
      {
        path: SubscriptionPathsEnum.SUBSCRIPTION_ID,
        element: <SubscriptionTabsLazy />,
        handle: {
          // This is a dynamic route
          // So the meta data needs to be sent from the route itself
          meta: (data) => data,
          crumb: (data) => data,
        },
      },
      {
        path: SubscriptionPathsEnum.BLA,
        element: <BaseLineAssessmentsLazy />,
      },
      {
        path: SubscriptionPathsEnum.BLA_END,
        element: <AssessmentCompleted />,
      },
      {
        path: SubscriptionPathsEnum.BLA_ONBOARDING,
        element: <GetStartedBLA />,
      },
      {
        path: SubscriptionPathsEnum.PHQ,
        element: <RedirectToPHQ />,
      },
      {
        path: "*",
        element: <NotFoundPage />,
      },
    ],
  },
];

export default SubscriptionRoutes;
